const defaultState = {
  unread_conversations: {},
  unread_msg: 0,
  list: [],
  messages: [],
  details: {},
  sidebarOpen: false,
  editSidebarOpen: false,
  composeSidebarOpen: false,
  composeConversation: null,
};

const conversations = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_COMPOSE_CONVERSATION":
      return { ...state, composeConversation: action.payload };

    case "SET_EDIT_SIDEBAR":
      return { ...state, editSidebarOpen: action.payload };

    case "SET_SIDEBAR":
      return { ...state, sidebarOpen: action.payload };

    case "SET_COMPOSE_SIDEBAR":
      return { ...state, composeSidebarOpen: action.payload };

    case "SET_UNREAD_CONVERSATIONS":
      return { ...state, unread_conversations: action.payload };

    case "SET_UNREAD_MESSAGES":
      return { ...state, unread_msg: action.payload };

    case "SET_CONVERSATIONS":
      return {
        ...state,
        list: action.payload,
      };

    case "SET_CONVERSATION_DETAILS":
      return {
        ...state,
        details: {
          ...action.payload,
        },
      };

    case "SET_MESSAGES":
      // console.log("setting messages", action.payload);
      return {
        ...state,
        messages: action.payload,
      };

    default:
      return state;
  }
};

export default conversations;
